import { Component, OnInit, Input } from '@angular/core';
import { IngetionService } from '../../../_services/ingetion.service'
import { TrainingService } from '../../../_services/training.service'
import { ContentSearchService } from '../../../_services/content-search.service';
import { VaLauncherService } from '../../../_services/va-launcher.service'
import { UserService } from '../../../_services/user.service'
import { VaService } from '../../../_services/va.service'
import { CommunictionService } from '../../../_services/communiction.service';
import { DomSanitizer } from '@angular/platform-browser';

import { LongProgressService, ACTIVE_TASK_USER_CONFIG_KEY } from '../../../_services/long-progress.service'
import { NotificationService } from '../../../_services/notification.service';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit {

  @Input() progress: any;
  checkStatusInterval;

  constructor(private ingetionService: IngetionService,
    private _trainingService: TrainingService,
    private _vaLauncherService: VaLauncherService,
    private _longProgressService: LongProgressService,
    private _contentSearchService: ContentSearchService,
    private _userService: UserService,
    private _vaService: VaService,
    private _communicationService: CommunictionService,
    protected html_sanitizer: DomSanitizer,
    private notificationService: NotificationService
  ) { }

  ngOnInit() {
    if(!this.progress.completed) {
      this.progress['current'] = 20
      this.progress['status'] = 'Loading'
      this.progress['isActive'] = true
      this.progress['statusClass'] = 'LOADING'
      this.progress['cancelFlag'] = false
      this.checkStatus();
    }
}

  checkStatus() {
    this.checkStatusInterval = setInterval(() => {
      if (this.progress['type'] == 'documentIngetion') {
        this.ingetionService.checkStatus(this.progress['activeProjectID'], this.progress['taskId']).subscribe((result) => {
          this.handleSuccess(result)
        })
      } else if (this.progress['type'] == 'training') {
        this._trainingService.checkStatus(this.progress['activeProjectID'], this.progress['taskId'], this.progress['parentId']).subscribe((result) => {
          this.handleSuccess(result)
        })
      } else if (this.progress['type'] == 'launch') {
        this._vaLauncherService.taskStatus(this.progress['activeProjectID'], this.progress['taskId']).subscribe((result) => {
          this.handleSuccess(result)
        })
      } else if (this.progress['type'] == 'documentLoad') {
        this.ingetionService.checkStatus(this.progress['activeProjectID'], this.progress['taskId']).subscribe((result) => {
          this.handleSuccess(result)
        })
      } else if (this.progress['type'] == 'botUploadStatus') {
        this._communicationService.checkStatus(this.progress['taskId']).subscribe((result) => {
          this.handleSuccess(result)
        })
      }
      else if (this.progress['type'] == 'contentTraining') {
        this._contentSearchService.checkStatus(this.progress['activeProjectID'], this.progress['taskId']).subscribe((result) => {
          if(result['similar_pairs'] && result['similar_pairs'].length > 0 ) {
            this.notificationService.showDuplicateDocsEvent.emit(result['similar_pairs']);
          }
          this.handleSuccess(result)
        })
      }
      else if (this.progress['type'] == 'acronyms') {
        this._trainingService.checkStatus(this.progress['activeProjectID'], this.progress['taskId']).subscribe((result) => {
          this.handleSuccess(result)
        })
      }
    }, 4000)
  }

  handleSuccess(result) {
    this.progress['status'] = this.html_sanitizer.bypassSecurityTrustHtml(result['status'])
    this.progress['current'] = result['current']
    this.progress['total'] = result['total']
    if (result['cancel']) {
      this.progress['cancelFlag'] = result['cancel']
    } else {
      this.progress['cancelFlag'] = false
    }

    if (result['current'] == result['total']) {
      this.progress['statusClass'] = result['state']
      this.stopProgress()

      let activeTasks = this._userService.getConfig(ACTIVE_TASK_USER_CONFIG_KEY)
      delete activeTasks[this.progress['activeProjectID']]
      this._userService.setConfig(ACTIVE_TASK_USER_CONFIG_KEY, activeTasks)
      // clearInterval(this.checkStatusInterval);

      if (this._vaService.activeAgent && this._vaService.activeAgent._id.$oid) {
        this._vaService.getAgent(this._vaService.activeAgent._id.$oid).subscribe(data => this._vaService.activeAgent = data)
      }

      this._longProgressService.progressCompletedEvent.emit({
        id: this.progress['id'],
        task_id: this.progress['taskId'],
        status: 'completed',
        result: result['result'],
        state: result['state'],
        message: result['message']
      });
    } else {

      this._longProgressService.progressPollingEvent.emit({
        id: this.progress['id'],
        task_id: this.progress['taskId'],
        status: 'progress',
        result: result['meta']
      });

    }
  }

  stopProgress() {
    this.progress.completed = true;
    clearInterval(this.checkStatusInterval);
    this.endProgressBar();
  }

  closeProgressBar() {
    this.progress['isActive'] = false
  }

  cancelProgress() {
    this._communicationService.cancelTask(this.progress['activeProjectID'], this.progress['taskId'], this.progress['parentId']).subscribe((result) => {
      this.handleSuccess(result)
    });
  }

  endProgressBar() {
    this.notificationService.endProgressEvent.emit({ progress: this.progress });
  }
}
